
import { UserInteraction, UserInteractionType, Product } from '../types';
import { storage } from '../lib/storage';
import { GoogleGenAI, Type } from "@google/genai";

const STORAGE_KEY = 'lynqar_user_interactions';

export const behaviorService = {
  track: (userId: string, productId: string, type: UserInteractionType) => {
    const data = localStorage.getItem(STORAGE_KEY);
    let all: UserInteraction[] = data ? JSON.parse(data) : [];
    
    all.push({
      userId,
      productId,
      type,
      timestamp: new Date().toISOString()
    });

    // Keep last 100 interactions for performance
    if (all.length > 100) all = all.slice(-100);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    window.dispatchEvent(new Event('behavior-update'));
  },

  getInteractions: (userId: string): UserInteraction[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: UserInteraction[] = data ? JSON.parse(data) : [];
    return all.filter(i => i.userId === userId);
  },

  getPersonalizedRecommendations: async (userId: string): Promise<Product[]> => {
    const interactions = behaviorService.getInteractions(userId);
    if (interactions.length === 0) return [];

    const allProducts = storage.getProducts();
    
    // Map interactions to product details for context
    const interactionContext = interactions.map(i => {
      const p = allProducts.find(prod => prod.id === i.productId);
      return { type: i.type, productName: p?.name, category: p?.categoryId };
    });

    try {
      const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
      const response = await ai.models.generateContent({
        model: 'gemini-3-flash-preview',
        contents: `Analyze these user interactions on an electronics store: ${JSON.stringify(interactionContext)}.
        Identify the user's primary interests. Based on this, pick exactly 3 products from this inventory that they would most likely buy:
        ${JSON.stringify(allProducts.map(p => ({ id: p.id, name: p.name, description: p.description, price: p.price })))}
        
        Return ONLY a JSON array of product IDs: ["p1", "p2", "p3"]`,
        config: {
          responseMimeType: "application/json",
          responseSchema: {
            type: Type.ARRAY,
            items: { type: Type.STRING }
          }
        }
      });

      const recommendedIds = JSON.parse(response.text);
      return allProducts.filter(p => recommendedIds.includes(p.id));
    } catch (e) {
      console.error("Personalization Error:", e);
      return [];
    }
  }
};
